import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { maxMediaQueries, minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
export var ISINLabel = styled.span.withConfig({
  displayName: "partials__ISINLabel",
  componentId: "sc-m6n7ga-0"
})(["white-space:nowrap;", ""], function (_ref) {
  var isActive = _ref.isActive;
  return isActive && css(["font-weight:700;color:", ";"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.font;
  });
});
export var InnerSpacing = styled.div.withConfig({
  displayName: "partials__InnerSpacing",
  componentId: "sc-m6n7ga-1"
})(["overflow-y:auto;height:100%;padding:50px 30px 0;background-color:", ";", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.background;
}, maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    overflow-y: auto;\n    height: 100%;\n  "]))));
export var Centered = styled.div.withConfig({
  displayName: "partials__Centered",
  componentId: "sc-m6n7ga-2"
})(["display:flex;align-items:center;justify-content:center;height:100%;"]);
export var TableScrollable = styled.div.withConfig({
  displayName: "partials__TableScrollable",
  componentId: "sc-m6n7ga-3"
})(["margin-top:24px;table{width:100%;", " ", ";", " td:not([scope='row']){padding:18px 12px;border-bottom:1px solid ", ";background-color:transparent;font-weight:400;white-space:normal;color:", ";text-align:", ";", ";", ";", ";", ";", ";", ";}}"], getFont('-1'), minMediaQueries.miniDesktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n      "])), getFont(0)), minMediaQueries.desktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        th {\n          &[scope='row'] {\n            width: 400px;\n          }\n        }\n      "]))), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.terciaryL;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.terciary;
}, function (_ref6) {
  var textAlign = _ref6.textAlign;
  return textAlign || 'left';
}, minMediaQueries.phone(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          min-width: 1px;\n          max-width: 170px;\n        "]))), minMediaQueries.phablet(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          min-width: 1px;\n          max-width: 170px;\n        "]))), minMediaQueries.tablet(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          min-width: 1px;\n          max-width: 180px;\n        "]))), minMediaQueries.miniDesktop(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          min-width: 1px;\n          max-width: 225px;\n        "]))), minMediaQueries.desktop(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          min-width: 1px;\n          max-width: 230px;\n        "]))), function (_ref7) {
  var wrapValue = _ref7.wrapValue;
  return wrapValue && wrapValue === 'nowrap' ? 'white-space: nowrap;' : '';
});